// extracted by mini-css-extract-plugin
export default {"section":"LimiterControl_section__HKCnT","container":"LimiterControl_container__RcRrJ","header":"LimiterControl_header__uCuxS","controlsFrame":"LimiterControl_controlsFrame__UFYmb"};